export default __webpack_public_path__ + "static/media/caret-down-white.e4ee8f6b.svg";